/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {internalUpdateInvestingCategorySettingsBackfill} from '../api'

export const useMutationInternalUpdateInvestingCategorySettingsBackfill = createReactQueryMutationHook('internalUpdateInvestingCategorySettingsBackfill', internalUpdateInvestingCategorySettingsBackfill)
